<div *ngIf="sticky" class="push"></div>
<div class="wrapper" [class.sticky]="sticky">
  <div class="container d-none d-xl-flex">
    <nav class="menu">
      <a routerLink="/" class="logo">
        <i class="icon-logo" [class.iconSticky]="sticky"></i>
      </a>
      <div class="spacer"></div>
      <a
        *ngIf="!isLoggedIn()"
        routerLink="/page/lite"
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.broker"
      >
        Lite
      </a>
      <a
        *ngIf="isLoggedIn()"
        routerLink="/lite"
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.broker"
      >
        Lite
      </a>

      <a
        *ngIf="!isLoggedIn()"
        routerLink="/page/pro"
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.exchange"
      >
        Pro
      </a>
      <a
        *ngIf="isLoggedIn()"
        routerLink="/pro"
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.exchange"
      >
        Pro
      </a>

      <!-- <a [href]="links.apiDocs" target="_blank" class="link" i18n="@@front.header.api">API</a> -->
      <a
        routerLink="/prices"
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.prices"
      >
        Prices
      </a>
      <!-- <a routerLink="/otc" routerLinkActive="active" class="link" i18n="@@front.header.otc">OTC</a> -->
      <a
        routerLink="/page/vip"
        routerLinkActive="active"
        class="link"
        i18n="@@front.footer.vip"
        >VIP</a
      >
      <a
        routerLink="/page/fees"
        routerLinkActive="active"
        class="link"
        i18n="@@front.footer.fees"
        >Fees</a
      >
      <a
        href="javascript:void(0)"
        class="link"
        data-bs-toggle="collapse"
        data-bs-target="#institutionsNav"
        aria-controls="institutionsNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        i18n="@@front.header.institutions"
      >
        Institutions
      </a>

      <a
        [href]="'https://learn.bitoasis.net/' + (isArabic ? 'ar' : 'en')"
        routerLinkActive="active"
        class="link"
        target="_blank"
        i18n="@@front.header.learn"
        >Learn</a
      >

      <a
        [routerLink]="
          isLoggedIn() ? ['/referral-program'] : ['/page/referral-program']
        "
        routerLinkActive="active"
        class="link"
        i18n="@@front.header.affiliate"
        >Referral Program</a
      >

      <a
        [href]="campaignHubUrl"
        target="_blank"
        class="link"
        i18n="@@front.header.campaignHub"
      >
        Campaign Hub
      </a>
      <!-- <a routerLink="/invite-and-win-competition" routerLinkActive="active" class="link" i18n="@@front.header.contests">Contests</a> -->
      <!-- <a routerLink="/page/fees" routerLinkActive="active" class="link" i18n="@@front.header.fees">Fees</a> -->
      <!-- <a [href]="links.blog" target="_blank" class="link" i18n="@@front.header.blog">Blog</a> -->
      <!-- <a routerLink="/about-us" class="link" i18n="@@front.header.aboutUs">About Us</a> -->
    </nav>

    <nav class="account">
      <div class="spacer"></div>
      <ng-container *ngIf="!isLoggedIn()">
        <a
          routerLink="/register"
          class="btn btn-fill"
          data-testid="register-btn"
          i18n="@@front.header.signup"
          [ga]="['Home Page Navigation', 'Sign Up']"
        >
          Create Account
        </a>
        <div class="spacer"></div>
        <a
          routerLink="/login"
          class="btn btn-border"
          data-testid="login-btn"
          i18n="@@front.header.login"
          [ga]="['Home Page Navigation', 'Login']"
          >Login</a
        >
        <!-- <div class="spacer"></div>
        <theme-switcher></theme-switcher> -->
        <div class="spacer"></div>
        <a
          *ngIf="!isArabic"
          class="ar"
          [href]="getArLink()"
          [ga]="['Home Page Navigation', 'Ar Language']"
        >
          العربية
        </a>
        <a
          *ngIf="isArabic"
          class="en"
          [href]="getEnLink()"
          [ga]="['Home Page Navigation', 'En Language']"
        >
          English
        </a>
      </ng-container>
      <ng-container *ngIf="isLoggedIn()">
        <a
          routerLink="/dashboard"
          class="btn btn-fill"
          i18n="@@front.header.dashboard"
          [ga]="['Home Page Navigation', 'Dashboard']"
        >
          Dashboard
        </a>
        <div class="spacer"></div>
        <a
          *ngIf="isVerified()"
          routerLink="/accounts"
          class="btn btn-border"
          i18n="@@front.header.wallets"
          [ga]="['Home Page Navigation', 'Accounts']"
        >
          Wallets
        </a>
        <a
          *ngIf="!isVerified()"
          routerLink="/kyc"
          class="btn btn-border"
          i18n="@@front.header.verify"
          [ga]="['Home Page Navigation', 'Verify']"
          >Verify Now</a
        >
        <!-- TODO: Uncomment this when we have a proper design for all pages -->
        <!-- <div class="spacer"></div>
          <theme-switcher></theme-switcher> -->
        <div class="spacer"></div>
        <app-user-menu
          [data]="user"
          [isIndividualVerificationEnabled]="isIndividualVerificationEnabled"
          [verificationStatus]="verificationStatus"
          [class.app-user-menu-sticky]="sticky && !isDarkMode"
        ></app-user-menu>
      </ng-container>
    </nav>
  </div>

  <div class="collapse navbar-collapse" id="institutionsNav">
    <div class="navbar-container">
      <a class="nav-item" routerLink="/otc">
        <div class="image-container">
          <img src="assets/images/corporates/pipes.svg" alt="pipes" />
        </div>
        <div class="text-container">
          <h4 i18n="@@front.header.otc.title">Over-the-Counter Trading</h4>
          <p i18n="@@front.header.otc.desc">
            Personalized service for large trades.
          </p>
        </div>
      </a>
      <a class="nav-item" routerLink="/corporates">
        <div class="image-container">
          <img src="assets/images/corporates/bank.svg" alt="bank" />
        </div>
        <div class="text-container">
          <h4 i18n="@@front.header.cororates.title">Corporates</h4>
          <p i18n="@@front.header.cororates.desc">
            Trusted Crypto platform for corporates
          </p>
        </div>
      </a>

      <p i18n="@@front.header.institutions.desc">
        Crypto services catering to Institutions, Family Offices & High Net
        worth Individuals
      </p>
    </div>
  </div>

  <div class="container d-flex d-xl-none" [class.light]="sticky">
    <nav class="menu">
      <mobile-menu-site
        [data]="user"
        [isIndividualVerificationEnabled]="isIndividualVerificationEnabled"
        [verificationStatus]="verificationStatus"
        [class.specific-menu]="sticky && !isDarkMode"
        (toggleMenu)="getProfile()"
      ></mobile-menu-site>
      <a routerLink="/" class="logo">
        <i class="icon-logo" [class.iconSticky]="sticky"></i>
      </a>
      <div class="col"></div>
      <div class="d-flex align-items-center">
        <!-- TODO: Uncomment this when we have a proper design for all pages -->
        <!-- <theme-switcher *ngIf="!isLoggedIn"></theme-switcher> -->
        <a
          *ngIf="!isLoggedIn()"
          routerLink="/login"
          class="btn-sm btn-mobile d-inline"
          i18n="@@front.header.login"
          >Login</a
        >
        <a
          *ngIf="!isArabic && !isLoggedIn()"
          class="ar d-inline px-2"
          [href]="getArLink()"
          [ga]="['Home Page Navigation', 'Ar Language']"
        >
          العربية
        </a>
        <a
          *ngIf="isArabic && !isLoggedIn()"
          class="en d-inline px-2"
          [href]="getEnLink()"
          [ga]="['Home Page Navigation', 'En Language']"
        >
          English</a
        >
        <a
          *ngIf="isLoggedIn()"
          routerLink="/dashboard"
          class="btn-sm btn-mobile"
          i18n="@@front.header.dashboard"
        >
          Dashboard
        </a>
      </div>
    </nav>
  </div>
</div>
